import { Pagination, Grid } from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetOrdersQueriesWithParamsQuery } from "../../api/queriesApi";
import { orderQueryParamsActions } from "../../store/queries/order-query-params-slice";
import OrderQueryResultTable from "../../components/tables/OrderQueryResultTable";

import Colors from "../../constants/Colors";

import Spinner from "../../components/layout/Spinner";
import OrdersQueryResultsTotalizersCard from "../../components/cards/queries/OrdersQueryResultsTotalizersCard";
import SearchFeedback from "../../components/feedback/SearchFeedback";

const OrdersQueriesResultsPage = () => {
  const queryParams = useAppSelector((state) => state.orderQueryParams);
  const { isError, isFetching, isLoading, data } =
    useGetOrdersQueriesWithParamsQuery(queryParams);

  const dispatch = useAppDispatch();

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    dispatch(orderQueryParamsActions.changePage(value));
  };

  if (isFetching || isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <>
        <h2>Erro ao carrgar dados dos pedidos</h2>
      </>
    );
  }

  if (data && data.pedidos.length === 0) {
    return (
      <>
        <SearchFeedback />
      </>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        <OrdersQueryResultsTotalizersCard
          orders={data ? data.pedidos : []}
          totalizador={data?.totalizador}
        />
        <Grid item xs={12} md={12}>
          <OrderQueryResultTable orders={data ? data.pedidos : []} />
        </Grid>
      </Grid>
      {data && data?.totalPages > 1 && (
        <Pagination
          size="small"
          showFirstButton
          showLastButton
          page={queryParams.page}
          count={data?.totalPages}
          sx={{
            "& .MuiPaginationItem-root": {
              "&.Mui-selected": {
                background: Colors.mainLayoutAtiveBackground,
                color: "black",
              },
            },
            width: "100%",
          }}
          onChange={handleChange}
        />
      )}
    </>
  );
};

export default OrdersQueriesResultsPage;
